import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import DOMpurify from "dompurify";
import { formatHref } from "ui/utils/formatters";

export const CustomMarkdown = ({ children }: { children: string }) => {
  const LinkRenderer = (props: any) => {
    return (
      <a
        className="hover:underline"
        href={formatHref(props.href)}
        target="_blank"
        rel="noreferrer"
      >
        {props.children}
      </a>
    );
  };

  const ParagraphRenderer = (props: any) => {
    return <span className="block whitespace-pre-wrap">{props.children}</span>;
  };

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      urlTransform={formatHref}
      components={{
        a: LinkRenderer,
        p: ParagraphRenderer,
      }}
    >
      {/* sanitize allows to render html tags safely */}
      {DOMpurify.sanitize(children)}
    </ReactMarkdown>
  );
};
